module.exports = __webpack_public_path__ + "media/images/app/trust/safetyMobile-1bf9d4a2bbafbe347fe7111fb8078ed9.webp";